var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRtuAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6H1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12h1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtuAssets);
export default __webpack_public_path__ + "static/media/rtu_assets.82d7d355eaf738ed3f01867ba9adfdc7.svg";
export { ForwardRef as ReactComponent };